/* OMG Watch Co. editorial motion layer.
 * Adapted for this single store from the licensed Studio Starter theme.
 */
(function () {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const inEditor = Boolean(window.Shopify && window.Shopify.designMode);

  function initReveal(root) {
    root.querySelectorAll([
      '.omg-team-card',
      '.omg-values-grid article',
      '.omg-return-grid article',
      '.omg-steps li',
      '.omg-faq__group',
      '.omg-form-card',
      '.omg-spec',
      '.omg-stat'
    ].join(',')).forEach((item) => item.classList.add('omg-reveal'));

    const items = root.querySelectorAll('.omg-reveal:not(.is-visible)');
    if (reduceMotion || inEditor || !('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -7% 0px' });

    items.forEach((item, index) => {
      item.style.setProperty('--omg-delay', `${Math.min(index % 5, 4) * 70}ms`);
      observer.observe(item);
    });
  }

  function initParallax(root) {
    if (reduceMotion || inEditor || window.matchMedia('(max-width: 899px)').matches || window.matchMedia('(pointer: coarse)').matches) return;
    const hosts = Array.from(root.querySelectorAll('[data-omg-parallax]'));
    if (!hosts.length) return;
    let ticking = false;

    const update = () => {
      ticking = false;
      hosts.forEach((host) => {
        const image = host.querySelector('img');
        if (!image) return;
        const rect = host.getBoundingClientRect();
        if (rect.bottom < -150 || rect.top > window.innerHeight + 150) return;
        const amount = Number(host.dataset.omgParallax) || 40;
        const progress = (rect.top - window.innerHeight) / (window.innerHeight + rect.height);
        const translate = Math.max(-amount / 2, Math.min(amount / 2, -progress * amount));
        image.style.transform = `translate3d(0, ${translate.toFixed(2)}px, 0) scale(1.07)`;
      });
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    update();
  }

  function initHeader() {
    const header = document.querySelector('.header-wrapper');
    if (!header || header.dataset.omgCompactReady === 'true') return;
    header.dataset.omgCompactReady = 'true';
    let ticking = false;

    const update = () => {
      ticking = false;
      header.classList.toggle('omg-header--compact', window.scrollY > 48);
    };

    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }, { passive: true });
    update();
  }

  function init(root = document) {
    initReveal(root);
    initParallax(root);
    initHeader();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
